import log from "../log";

export default () => {
	const { gameInfo, ads } = gameSettings;

	const anchoWindow = $(window).width();
	const gameAncho = gameInfo.size_x;
	const anchoRelacionadosIzquierda = $(
		".GameScreen-GameBox-related--izquierda",
	).width();
	const $GameScreen = $(".GameScreen");
	const $bannerDerecha = $(".Banners-lateral");

	const propsGameScreen = {
		width: gameAncho + anchoRelacionadosIzquierda + 32,
	};

	let deltaEspacio = anchoWindow - propsGameScreen.width;
	log(__filename, { deltaEspacio });
	// Probamos 1 columna de relacionados + publi

	if (deltaEspacio < 140) {
		// No cabe publicidad
		$bannerDerecha.hide();
	} else if (deltaEspacio < 324) {
		// Cabe un banner de 120, pero no de 300
		propsGameScreen["margin-left"] = (deltaEspacio - 140) / 2;
		$bannerDerecha.html(ads.l120);
	} else {
		// Cabe un banner de 300, pero no dos barras de juegos relacionados
		propsGameScreen["margin-left"] = (deltaEspacio - 324) / 2;
		$bannerDerecha.html(ads.l300);
	}
	if (deltaEspacio > 500) {
		// Ademas del banner nos caben los relacionados
		propsGameScreen.width += anchoRelacionadosIzquierda + 32; // En realidad queremos agregarle el de la derecha

		// Agregamos otra barra lateral, así que debemos recalcular el deltaEspacio
		deltaEspacio = anchoWindow - propsGameScreen.width;
		propsGameScreen["margin-left"] = (deltaEspacio - 324) / 2;

		// Agregamos modificador a relacionados derecha para que queden hacia abajo
		$(".GameScreen-GameBox-related--derecha").addClass(
			"GameScreen-GameBox-related--derecha--vertical",
		);
	}

	$GameScreen.css(propsGameScreen);
	$(".Main,.Footer").css(propsGameScreen);
	$(".Banners-lateral--derecha").css({
		left: $(".GameScreen").offset().left + propsGameScreen.width + 20,
		right: "auto",
	});
	// GameBox Adjust
};
